import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { FormattedMessage } from 'react-intl';
import DownloadIcon from './DownloadIcon';
import { getOptions } from '../textBlock/TextBlockWithIcon';
import { withRouteData } from 'react-static';
import { getArtworkUrl } from '../utils/Contentful';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  padding: 1rem;

  > :not(:last-child) {
    margin-bottom: 1rem;
  }

  ${media.mediumLarge`
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    > :not(:last-child) {
      margin-bottom: 0;
      margin-right: 1rem;
    }
  `};
`;

const Image = styled.div`
  ${media.mediumLarge`
    flex: 1 1 30%;
    max-width: 50%;
  `}

  img {
    height: auto;
    width: 100%;
  }
`;

const Description = styled.div`
  text-align: center;
  ${media.mediumLarge`
    flex: 1 1 70%;
    text-align: left;
  `}

  .title {
    font-weight: 600;
    font-size: var(--fs-m);
    ${legacyType('m', 'title', { emphasis: true })};
  }

  .subtitle {
    font-size: var(--fs-focus);
    white-space: pre-line;
    ${legacyType('focus', 'body')};

    a {
      text-decoration: underline;
    }

    p {
      margin-bottom: 0;
    }
  }
`;

const DownloadLink = styled.a`
  text-transform: uppercase;
  text-decoration: underline;
  color: var(--c-red);
  font-size: var(--fs-focus);
  padding: 1rem 0;
  ${legacyType('focus', 'label', { uppercase: true })};
  display: inline-flex;
  justify-content: center;
  align-items: flex-start;

  > :not(:last-child) {
    margin-right: 10px;
  }

  ${media.mediumLarge`
    justify-content: left;
  `};
`;

const PressResource = ({ content, basename }) => {
  const { title, subtitle, image, file } = content;

  return (
    <Wrapper>
      <Image>
        <img src={getArtworkUrl(image)} alt="" />
      </Image>
      <Description>
        {title && <div className="title">{title}</div>}
        {subtitle && (
          <div className="subtitle">
            {documentToReactComponents(subtitle, getOptions(basename))}
          </div>
        )}
        {file && (
          <DownloadLink href={getArtworkUrl(file)}>
            <FormattedMessage defaultMessage="Download" id="press-resources.download-label" />
            <DownloadIcon size={21} />
          </DownloadLink>
        )}
      </Description>
    </Wrapper>
  );
};

PressResource.propTypes = {
  content: PropTypes.object,
  basename: PropTypes.string.isRequired,
};

export default withRouteData(PressResource);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/press/PressResource.js